// Top bar, mobile drawer, search, and the account menu.
export default {
  en: {
    openMenu: 'Open navigation menu',
    closeMenu: 'Close navigation menu',
    searchPlaceholder: 'Search games, library…',
    cart: 'Cart',
    accountMenu: '{name} menu',
    favourites: 'Favourites',
    orders: 'Orders',
    articles: 'Articles',
    settings: 'Settings',
    account: 'Account',
    dashboard: 'Dashboard',
    billing: 'Billing',
    billingWallet: 'Billing & Wallet',
    signOut: 'Sign out',
    logIn: 'Log in',
    signUp: 'Sign up',
    yourAccount: 'Your account',
    utility: 'Site links',
    browse: 'Browse',
    shortcuts: 'Shortcuts',
    menu: 'Menu',
    allGames: 'All games',
    deals: 'Deals',
    newReleases: 'New releases',
    help: 'Help & FAQ',
    terms: 'Terms',
    platforms: 'Platforms',
    genres: 'Genres',
    genresEmpty: 'Genres appear once the catalog has synced.',
    shopByPrice: 'Shop by price',
    giftCards: 'Gift cards & top-ups',
    language: 'Language',
  },
  cs: {
    openMenu: 'Otevřít navigační menu',
    closeMenu: 'Zavřít navigační menu',
    searchPlaceholder: 'Hledat hry, knihovnu…',
    cart: 'Košík',
    accountMenu: 'Menu {name}',
    favourites: 'Oblíbené',
    orders: 'Objednávky',
    articles: 'Články',
    settings: 'Nastavení',
    account: 'Účet',
    dashboard: 'Přehled',
    billing: 'Platby',
    billingWallet: 'Platby a peněženka',
    signOut: 'Odhlásit se',
    logIn: 'Přihlásit se',
    signUp: 'Registrovat se',
    yourAccount: 'Váš účet',
    utility: 'Odkazy webu',
    browse: 'Procházet',
    shortcuts: 'Zkratky',
    menu: 'Menu',
    allGames: 'Všechny hry',
    deals: 'Slevy',
    newReleases: 'Novinky',
    help: 'Nápověda a časté dotazy',
    terms: 'Podmínky',
    platforms: 'Platformy',
    genres: 'Žánry',
    genresEmpty: 'Žánry se zobrazí po synchronizaci katalogu.',
    shopByPrice: 'Podle ceny',
    giftCards: 'Dárkové karty a dobití',
    language: 'Jazyk',
  },
};
